import Vue from 'vue';
import Router from 'vue-router';

import config from '../config';

import agent from '../components/agent/agent.vue';
import auth from '../components/auth';
import collectionList from '../components/collection/collection-list.vue';
import collectionParcels from '../components/collection/collection-parcels.vue';
import collectionUnlocked from '../components/collection/collection-unlocked.vue';
import communityPlan from '../components/community-plan/community-plan.vue';
import communityPlanEdit from '../components/community-plan/community-plan-edit.vue';
import feature from '../components/feature/feature.vue';
import featureList from '../components/feature/feature-list.vue';
import home from '../components/home/home.vue';
import overlayEdit from '../components/overlay/overlay-edit.vue';
import overlayFull from '../components/overlay/overlay-full.vue';
import overlayList from '../components/overlay/overlay-list.vue';
import parcelPage from '../components/parcel/parcel-page.vue';
import permit from '../components/permit/permit.vue';
import permitFull from '../components/permit/permit-full.vue';
import permitList from '../components/permit/permit-list.vue';
import plan from '../components/plan/plan.vue';
import sewerMainFull from '../components/sewer-main/sewer-main-full.vue';
import unlock from '../components/unlock/unlock.vue';
import waterMainFull from '../components/water-main/water-main-full.vue';
import zoning from '../components/zoning/zoning.vue';
import zoningEdit from '../components/zoning/zoning-edit.vue';

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: config.routerBase,
	fallback: false,
    routes: [
        {path: '/permits/:map?', component: permit, children:[
            {name:'permitsSearch',path:'/permits/search/:search/:map?', component:permitList,
                props:(route)=>{
                    const search = route.params.search
                    return { search }
                }
            },
            {name:'permit', path: '/permits/:id/:map?', component: permitFull,
                props:(route)=>{
                    const id = Number.parseInt(route.params.id, 10)
                    return { id }
                }
            },
            {name:'permits',path:'', component:permitList},
        ]},
    	{name:'home', path: '/:map?',component: home, children:[
            {name:'agent-tab', path: '/agent/:tab/:map?', component: agent,
                props:(route)=>{
                    const tab = route.params.tab
                    return { tab }
                },
            },
            {name:'agent', path: '/agent/:map?', component: agent},
            {name:'auth-tab', path: '/auth/:tab/:map?', component: auth,
                props:(route)=>{
                    const tab = route.params.tab
                    return { tab }
                },
            },
            {name:'auth', path: '/auth', component: auth},
            {name:'collection-unlocked',path:'/collections/unlocked/:map?', component:collectionUnlocked},
            {name:'collection-parcel-tab',path:'/collections/:collectionId/parcel/:parcelId/tab/:tab/:map?', component:collectionParcels,
                props:(route)=>{
                    const parcelId = Number.parseInt(route.params.parcelId, 10)
                    const collectionId = Number.parseInt(route.params.collectionId, 10)
                    const tab = route.params.tab
                    return { collectionId, parcelId, tab }
                }
            },
            {name:'collection-parcel',path:'/collections/:collectionId/parcel/:parcelId/:map?', component:collectionParcels,
                props:(route)=>{
                    const parcelId = Number.parseInt(route.params.parcelId, 10)
                    const collectionId = Number.parseInt(route.params.collectionId, 10)
                    return { collectionId, parcelId }
                }
            },
            {name:'collection',path:'/collections/:collectionId/:map?', component:collectionParcels, 
                props:(route)=>{
                    const collectionId = Number.parseInt(route.params.collectionId, 10)
                    return { collectionId }
                }
            },
            {name:'collections',path:'collections/:map?', component:collectionList},
    		{name:'community-plans',path:'/community-plans/:id/:map?',component:communityPlan,
                props:(route)=>{
                    const id = Number.parseInt(route.params.id, 10)
                    return { id }
                }
            },
            {name:'community-plan-edit',path:'/community-plans/:id/edit/:map?',component:communityPlanEdit,
                props:(route)=>{
                    const id = Number.parseInt(route.params.id, 10)
                    return { id }
                }
            },
            {name:'features',path:'/features/:lng/:lat/:map?', component:featureList,
                props:(route)=>{
                    const lng = Number(route.params.lng)
                    const lat = Number(route.params.lat)
                    return { lng, lat }
                }
            },
            {name:'overlay', path: '/overlays/:id/:map?', component: overlayFull},
            {name:'overlay-edit', path: '/overlays/:id/edit/:map?', component: overlayEdit},
            {name:'overlays',path:'', component:overlayList},
    		{name:'parcels', path: '/parcels/:id/:map?', component: parcelPage,
                props:(route)=>{
                    const id = Number.parseInt(route.params.id, 10)
                    return { id }
                }
            },
            {name:'parcel-service', path: '/parcels/:id/service/:categoryId/:map?', component: parcelPage, 
                props:(route)=>{
                    const id = Number.parseInt(route.params.id, 10)
                    const categoryId = route.params.categoryId
                    return { id, categoryId }
                }
            },
            {name:'parcels-tab', path: '/parcels/:id/:tab/:map?', component: parcelPage, 
                props:(route)=>{
                    const id = Number.parseInt(route.params.id, 10)
                    const tab = route.params.tab
                    return { id, tab }
                }
            },
            {name:'plan', path: '/plan/:map?', component: plan},
            {name:'search', path: '/search/:search/:map?'},
            {name:'unlock', path: '/unlock/:map?', component: unlock},
            {name:'unlock-parcel', path: '/unlock-parcel/:parcelId/:map?', component: unlock},
            {name:'sewer-main',path:'/sewer-main/:id/:map?',component: sewerMainFull},
            {name:'water-main',path:'/water-main/:id/:map?',component: waterMainFull},
            {name:'zoning-edit', path: '/zoning/:id/edit/:map?', component: zoningEdit},
            {name:'zoning', path: '/zoning/:id/:map?', component: zoning},
    	]}       	
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js